export const STATUSES = {
  normal: 'UNSAVED',
  progress: 'SAVING',
  success: 'SAVED',
  error: 'ERROR',
};
